import { render, staticRenderFns } from "./PublishProductsModal.vue?vue&type=template&id=1dc40656"
import script from "./PublishProductsModal.vue?vue&type=script&lang=js"
export * from "./PublishProductsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports